import React, { useEffect } from 'react'
import { createFileRoute, useNavigate, redirect } from '@tanstack/react-router'
import { useAuth } from '@/hooks/useAuth'
import { getPostLoginRedirect } from '@/lib/auth-redirect'

export const Route = createFileRoute('/_auth/')({
  component: HomePage,
})

function HomePage() {
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        // User is authenticated, redirect based on role
        const redirectPath = getPostLoginRedirect(user)
        navigate({ to: redirectPath })
      } else {
        // User is not authenticated, redirect to login
        navigate({ to: '/login' })
      }
    }
  }, [user, isLoading, navigate])

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-secondary">Loading...</p>
        </div>
      </div>
    )
  }

  return null
}
